import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  flagMessageList: [],
  totalCount: 0,
};
const slice = createSlice({
  name: "flagMessageList",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getFlagMessages.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getFlagMessages.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      flagMessageList: payload.data,
      totalCount: payload.totalcount,
    }));
    builder.addCase(Act.getFlagMessages.rejected, (state, action) => ({
      ...state,
      loading: false,
      flagMessageList: [],
      totalCount: 0,
    }));
  },
});

export default slice